// frontend/src/utils/displayName.ts
export type AnyUser = {
  name?: string;
  displayName?: string;
  fullName?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
};

export function displayName(user: AnyUser | null | undefined): string {
  if (!user) return 'User';
  const rawName =
    user.name ||
    user.displayName ||
    user.fullName ||
    (user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : '') ||
    user.username ||
    'User';

  const cleaned = String(rawName).trim();
  // If the name is empty or equals the username, derive a friendly name from the handle
  const uname = String(user.username || '').trim();
  if (!cleaned || cleaned.toLowerCase() === uname.toLowerCase()) {
    const base = uname || 'User';
    const tokens = base.split(/[._\-\s]+/).filter(Boolean);
    const pretty = tokens
      .map((t) => t.charAt(0).toUpperCase() + t.slice(1))
      .join(' ')
      .trim();
    return pretty || 'User';
  }
  return cleaned;
}
